export default __webpack_public_path__ + "static/media/logo.a23370e3.svg";